import { all } from "redux-saga/effects"
import handleAcceptInvite from "./handleAcceptInvite"
import handleCreateInvite from "./handleCreateInvite"
import handleDeleteInvite from "./handleDeleteInvite"
import handleFetchInvite from "./handleFetchInvite"

export default function* () {
  yield all([handleCreateInvite, handleDeleteInvite, handleAcceptInvite, handleFetchInvite])
}
